export default __webpack_public_path__ + "static/media/closeBlack.7b94ae05.svg";